import React from "react";
import { Col, Button } from "reactstrap";
import { getCookie } from "../jwt/_helpers/cookie";
import AsyncDropdownNormal from "./asyncDropdownNormal";

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const SubUserFilter = ({ subUserData, variant, selectStyles }) => {
  const token = getCookie("token");
  const isToolbar = variant === "toolbar";

  const dropdown = (
    <AsyncDropdownNormal
      endpoint="sub-users"
      subUserEndpoint=""
      parentUserOnly=""
      queryParams="&page=1&page_size=10"
      labelField="friendly_name"
      valueField="id"
      placeholder="Select Sub-User"
      fetchOptions={{
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": X_API_KEY,
          "Content-Type": "application/json",
        },
      }}
      onChange={(subUserObj) => {
        const friendlyName = subUserObj.label;
        const subUserId = subUserObj.value;
        if(subUserId !== '') {
          subUserData.setSubUser(friendlyName);
          subUserData.setSubUserEndpoint(`sub-user/${subUserId}/`);
          subUserData.setParentUserOnly('');
        } else {
          subUserData.setSubUser('');
          subUserData.setSubUserEndpoint('');
          subUserData.setParentUserOnly('');
        }
      }}
      className={isToolbar ? "release-toolbar-subuser-select" : "artistType"}
      classNamePrefix={isToolbar ? "release-filter" : undefined}
      components={isToolbar ? { IndicatorSeparator: () => null } : undefined}
      styles={isToolbar ? selectStyles : { menu: (styles) => ({ ...styles, zIndex: 10 }) }}
    />
  );

  const resetButton = subUserData.subUser && (
    <Button className={`btn btn-outline-info${isToolbar ? " release-toolbar-subuser-reset" : ""}`}
      onClick={() => {
        subUserData.setSubUser('');
        subUserData.setSubUserEndpoint('');
        subUserData.setParentUserOnly('');
      }}
    >
      Reset
    </Button>
  );

  if (isToolbar) {
    return (
      <>
        <div className="release-toolbar-subuser">
          <div className="release-toolbar-select-inner">
            {subUserData.subUser ? (
              <span className="release-toolbar-subuser-value" title={subUserData.subUser}>
                {subUserData.subUser}
              </span>
            ) : (
              dropdown
            )}
          </div>
        </div>
        {resetButton}
      </>
    );
  }

  return (
    <>
    <Col>
        {
            subUserData.subUser ?
            <div className="releaseFileRow">
                <p className="releaseFileRowName"><b>Sub-User: </b> {subUserData.subUser}</p>
            </div>
            :
            dropdown
        }
        </Col>
        <Col>
            {
                resetButton
            }
        </Col>
    </>
  );
};

export default SubUserFilter;
